// frontend\src\components\analytics\RevenueBasisInfo.tsx
import React from 'react';
import { AnalyticsRevenueBasis } from '../../types';

/**
 * Revenue is measured two different ways depending on the active filters, which is deliberate
 * but surprising when the total moves as soon as you filter. This marker explains which one
 * produced the number next to it.
 */
export const revenueBasisText = (basis: AnalyticsRevenueBasis): string =>
  basis === 'itemTotal'
    ? 'Revenue here is the value of the matching line items only (price x quantity), because a ' +
      'product, tag or supplier filter is active and only part of each order matches it. ' +
      'Shipping and tax are not included, so this will not match the unfiltered total.'
    : 'Revenue here is the net order total (order value less shipping and tax). Filtering by a ' +
      'product, tag or supplier switches to the value of the matching line items instead, which ' +
      'excludes shipping and tax - so the two are not directly comparable.';

interface RevenueBasisInfoProps {
  basis?: AnalyticsRevenueBasis;
}

const RevenueBasisInfo: React.FC<RevenueBasisInfoProps> = ({ basis }) => {
  if (!basis) return null;
  return (
    <span
      className="analytics-info-tip"
      title={revenueBasisText(basis)}
      role="img"
      aria-label={revenueBasisText(basis)}
    >
      i
    </span>
  );
};

export default RevenueBasisInfo;
